import React, { useState } from 'react'
import CollectionItems from './CollectionItems'
import { emptyFunction, showToast } from '../../../utils'
import { makeDeleteCall, makeGetCall } from '../../../effects/requests'
import { endPoints } from '../../../utils/endpoints'
import { ApiResponseType } from '../../../types'
import NoData from '../../../global/ui/NoData'
import DeleteCollectionPopup from './DeleteCollectionPopup'
import CollectionImages from './CollectionImages'
import ImageFullScreenViewer from '../../../global/ImageFullScreenViewer'

const Collections = ({ allData, onRefresh, myVault }: any) => {

    const [selectedColId, setSelectedColId] = useState<any>(null)
    const [selectedColData, setSelectedColData] = useState<any>(null)
    const [selectedImages, setSelectedImages] = useState<any>([])
    const [viewerOpen, setViewerOpen] = useState(false);

    const handleRemoveCol = () => {
        const url = `${endPoints.LOCATION_COLLECTION}${selectedColId}/`
        makeDeleteCall(url).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                showToast(res?.status?.message, "success")
                onRefresh?.()
            }
            setSelectedColId(null)
        }).catch(() => setSelectedColId(null))
    };

    const handleImageShow = (item: any) => {
        makeGetCall(endPoints.LOCATION_COLLECTION_IMAGES, { collection_id: selectedColData?.id, location_id: item?.id }).then((res: ApiResponseType<any>) => {
            if (res?.status?.code == 200) {
                const data = res?.results?.length > 0 ? res?.results : [];
                if (data?.length <= 0) {
                    showToast('No image found.', 'error');
                    return
                }
                setSelectedImages(data)
                setViewerOpen(true)
            }
        })
    }

    if (allData?.length === 0 || myVault) {
        return <NoData />
    }

    return (
        <>
            {selectedColData?.id &&
                <div style={{ marginBottom: 10 }} className="ld-breadcrumb">
                    <button type='button' onClick={() => setSelectedColData(null)} className="ld-breadcrumb__link">Collections</button>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="9 18 15 12 9 6" />
                    </svg>
                    <span className="ld-breadcrumb__current">{selectedColData?.name || ''}</span>
                </div>
            }

            {selectedColData?.id
                ?
                <CollectionImages
                    collectionDetails={selectedColData}
                    onClick={(item: any) => handleImageShow(item)}
                />
                :
                <div className={`lv-grid`}>
                    {allData?.map((item: any) => {
                        return (
                            <CollectionItems
                                key={item?.id}
                                item={item}
                                onClick={(data: any) => setSelectedColData(data)}
                                onDelete={setSelectedColId}
                            />
                        )
                    })}
                </div>
            }

            {selectedColId &&
                <DeleteCollectionPopup
                    onClose={() => setSelectedColId(null)}
                    onDelete={handleRemoveCol}
                />
            }

            {viewerOpen &&
                <ImageFullScreenViewer
                    isOpen={viewerOpen}
                    images={selectedImages}
                    initialIndex={0}
                    onClose={() => {
                        setViewerOpen(false)
                        setSelectedImages([])
                    }}
                    onDownload={emptyFunction}
                    onInfo={emptyFunction}
                    onDelete={emptyFunction}
                />
            }
        </>
    )
}

export default Collections